import {FontAwesomeButtonEnumTypes} from "../../../components/cards/FontAwesomeButtonEnumTypes";
import {faEnvelope} from "@fortawesome/free-solid-svg-icons/faEnvelope";
import {faEnvelopeCircleCheck} from "@fortawesome/free-solid-svg-icons/faEnvelopeCircleCheck";
import {faEnvelopeOpen} from "@fortawesome/free-solid-svg-icons/faEnvelopeOpen";
import {faCheckCircle} from "@fortawesome/free-regular-svg-icons/faCheckCircle";
import {faExclamationTriangle} from "@fortawesome/free-solid-svg-icons/faExclamationTriangle";
import {IconDefinition} from "@fortawesome/free-solid-svg-icons";

export class SC_QCReportStatuses {
    static readonly ALL = 0;
    static readonly IVR_NO_SHOW = 1;
    static readonly NOT_ISSUED = 2;
    static readonly AWAITING_CLIENT = 3;
    static readonly FINAL_REVIEW = 4;
    static readonly COMPLIANCE_ERROR = 5;
    static readonly COMPLETE = 6;

    constructor(private flagReport: number = SC_QCReportStatuses.NOT_ISSUED) { }

    static fromAPI(apiValue: number): SC_QCReportStatuses {
        switch (Number(apiValue)) {
            case SC_QCReportStatuses.ALL:
                return new SC_QCReportStatuses(SC_QCReportStatuses.ALL);
            case SC_QCReportStatuses.IVR_NO_SHOW:
                return new SC_QCReportStatuses(SC_QCReportStatuses.IVR_NO_SHOW);
            case SC_QCReportStatuses.NOT_ISSUED:
                return new SC_QCReportStatuses(SC_QCReportStatuses.NOT_ISSUED);
            case SC_QCReportStatuses.AWAITING_CLIENT:
                return new SC_QCReportStatuses(SC_QCReportStatuses.AWAITING_CLIENT);
            case SC_QCReportStatuses.FINAL_REVIEW:
                return new SC_QCReportStatuses(SC_QCReportStatuses.FINAL_REVIEW);
            case SC_QCReportStatuses.COMPLIANCE_ERROR:
                return new SC_QCReportStatuses(SC_QCReportStatuses.COMPLIANCE_ERROR);
            case SC_QCReportStatuses.COMPLETE:
                return new SC_QCReportStatuses(SC_QCReportStatuses.COMPLETE);
            default:
                return new SC_QCReportStatuses();
        }
    }

    is(type: number): boolean {
        return this.flagReport === type;
    }

    toAPI(): number {
        return this.flagReport;
    }

    clone(): SC_QCReportStatuses {
        return new SC_QCReportStatuses(this.flagReport);
    }

    static readonly qcReportStatuses = [
        { key: SC_QCReportStatuses.ALL, value: "All" },
        { key: SC_QCReportStatuses.IVR_NO_SHOW, value: "IVR No Show - Send QC ASAP", className: "QCIVRNoShow" },
        { key: SC_QCReportStatuses.NOT_ISSUED, value: "Not Issued", className: "QCNotIssued" },
        { key: SC_QCReportStatuses.AWAITING_CLIENT, value: "Awaiting Client", className: "QCAwaitingClient" },
        { key: SC_QCReportStatuses.FINAL_REVIEW, value: "Final Review", className: "QCFinalReview" },
        { key: SC_QCReportStatuses.COMPLIANCE_ERROR, value: "Compliance Error QC", className: "QCComplianceError" },
        { key: SC_QCReportStatuses.COMPLETE, value: "Compliance Complete QC", className: "QCComplianceComplete" },
    ];

    get className(): string {
        switch (this.flagReport) {
            case SC_QCReportStatuses.IVR_NO_SHOW:
                return "QCIVRNoShow";
            case SC_QCReportStatuses.NOT_ISSUED:
                return "QCNotIssued";
            case SC_QCReportStatuses.AWAITING_CLIENT:
                return "QCAwaitingClient";
            case SC_QCReportStatuses.FINAL_REVIEW:
                return "QCFinalReview";
            case SC_QCReportStatuses.COMPLIANCE_ERROR:
                return "QCComplianceError";
            case SC_QCReportStatuses.COMPLETE:
                return "QCComplianceComplete";
            default:
                return "";
        }
    }

    get buttonType(): FontAwesomeButtonEnumTypes {
        return new FontAwesomeButtonEnumTypes({
            mainColor: this.className,
        });
    }

    get icon(): IconDefinition {
        switch (this.flagReport) {
            case SC_QCReportStatuses.IVR_NO_SHOW:
                return faExclamationTriangle;
            case SC_QCReportStatuses.NOT_ISSUED:
                return faEnvelope;
            case SC_QCReportStatuses.AWAITING_CLIENT:
                return faEnvelopeCircleCheck;
            case SC_QCReportStatuses.FINAL_REVIEW:
                return faEnvelopeOpen;
            case SC_QCReportStatuses.COMPLIANCE_ERROR:
                return faEnvelope;
            case SC_QCReportStatuses.COMPLETE:
                return faCheckCircle;
            default:
                return null;
        }
    }
}
